<mat-card *ngIf="matchInfo" class="match-header-card">
  <mat-card-content class="header-content">

    <div class="scoreboard">

      <div class="team home-team">
        <a [routerLink]="['/statistics/team', matchInfo.home_team_id]" class="team-name">
          {{ matchInfo.home_team_name }}
        </a>
      </div>

      <div class="score-container">
        <span class="score">{{ matchInfo.home_score }}</span>
        <span class="score-separator">-</span>
        <span class="score">{{ matchInfo.away_score }}</span>
      </div>

      <div class="team away-team">
        <a [routerLink]="['/statistics/team', matchInfo.away_team_id]" class="team-name">
          {{ matchInfo.away_team_name }}
        </a>
      </div>

    </div>

    <div class="metadata-bar">

      <div class="meta-item">
        <mat-icon>calendar_today</mat-icon>
        <span>{{ matchInfo.match_date | date: 'fullDate' }}</span>
      </div>

      <div class="meta-item">
        <mat-icon>emoji_events</mat-icon>
        <span>{{ matchInfo.competition_name }} ({{ matchInfo.category_name }})</span>
      </div>

      <div class="meta-item" *ngIf="matchInfo.match_day">
        <mat-icon>tag</mat-icon>
        <span>Jornada {{ matchInfo.match_day }}</span>
      </div>

      <div class="meta-item" *ngIf="matchInfo.home_team_stadium">
        <mat-icon>stadium</mat-icon>
        <span>{{ matchInfo.home_team_stadium }}</span>
      </div>

    </div>

  </mat-card-content>
</mat-card>
